<template>
	<BaseLoading v-if="isLoading" is-full-page />
	<BannerSmallForm
		v-else
		is-edit-mode
		:is-loading="isLoading"
		:is-updating="isUpdating"
		:data="data"
		:banner-type="bannerType"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import BannerSmallForm from '@/components/BannerSmallForm.vue';

import { BANNER_TYPE } from '../enums/banners';
import { HOMEPAGE_COMPONENTS } from '../enums/homepage';
import { ROUTE_NAME } from '../enums/route';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'BannerSmallEdit',

	components: {
		BannerSmallForm,
	},

	props: {
		bannerType: {
			type: String,
			default: BANNER_TYPE.small,
		},
		context: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			id: Number(this.$route.params.id) || null,
		};
	},

	computed: {
		...mapState('banners', {
			edit: 'edit',
		}),

		...mapGetters({
			getBannerGroupDetail: 'banners/getBannerGroupDetail',
		}),

		isLoading() {
			return this.edit.isLoading;
		},

		isUpdating() {
			return this.edit.isUpdating;
		},

		data() {
			return this.getBannerGroupDetail;
		},
	},

	watch: {
		data(value) {
			this.setPageTitle({
				title: value.name,
				isShow: true,
			});
		},
	},

	async created() {
		await this.getBannerGroup({ id: this.id, type: this.bannerType });

		this.setPageTitle({
			title: this.data.name,
			isShow: true,
		});

		const breadcrumbTitle = HOMEPAGE_COMPONENTS.BANNER_SMALL.title;
		const breadcrumbRouteName = ROUTE_NAME.BANNER_SMALL_LIST;

		this.addBreadcrumb({
			title: breadcrumbTitle,
			route: {
				name: breadcrumbRouteName,
			},
		});
	},

	methods: {
		...mapActions({
			setPageTitle: 'pageTitle/setPageTitle',
			addBreadcrumb: 'breadcrumb/addBreadcrumb',
			showToast: 'toast/showToast',

			getBannerGroup: 'banners/getBannerGroup',
			updateBannerGroup: 'banners/updateBannerGroup',
		}),

		async handleSubmit(updatedData) {
			try {
				await this.updateBannerGroup({ id: this.id, params: updatedData });
			} finally {
				scrollToTop();
			}
		},
	},
};
</script>
